import throttle from "just-throttle";
import Lenis from "lenis";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

import header from "./header";

function loadHubSpotForm(containerId = 'hubspot-form-container') {
  
  const container = document.getElementById(containerId);
  if (!container) {
    console.error('❌ HubSpot container not found:', containerId);
    return;
  }

  // Obtener el form ID del data attribute
  const formId = container.dataset.formId;
  if (!formId) {
    console.error('❌ Form ID not found in data-form-id attribute');
    return;
  }

  // Función para inicializar el formulario
  function initHubSpotForm() {
    
    const formStyle = `
      <style>
        .hs-form { margin-bottom: 0; }
        .hs-form iframe { width: 100% !important; }
        .hs-form .hs-form-field .hs-input {
          height: 60px !important;
          font-size: 18px !important;
          border-radius: 4px !important;
          padding-block: 16px !important;
          padding-inline: 24px !important;
          background-color: white !important;
          border: 2px solid #757575 !important;
        }
        .hs-form .hs-form-field label {
          top: 15px !important;
          font-size: 18px !important;
          position: relative;
          padding-left: 15px !important;
        }
        .hs-form .hs-form-field label span {
          padding-inline: 10px !important;
          display: inline-block !important;
          background-color: white !important;
        }
        .hs-form .hs-form-field label span.hs-form-required {
          left: -10px;
          padding-left: 0 !important;
          position: relative;
        }
        .hs-form .hs-form-field select {
          appearance: none;
          -webkit-appearance: none;
          -moz-appearance: none;
          background: url('data:image/svg+xml;utf8,<svg fill="black" height="16" viewBox="0 0 24 24" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/></svg>') no-repeat;
          background-position: right 1rem center;
          padding-right: 2.5rem;
          background-size: 1rem;
        }
        .hs-form .hs-form-field textarea {
          min-height: 150px !important;
        }
        .hs-form .hs-form-field input, .hs-form .hs-form-field select, .hs-form .hs-form-field textarea { 
          font-size: 18px;
          font-family: "Lexend Deca", sans-serif !important;
        }
        .hs-form .legal-consent-container .inputs-list {
          padding-left: 0 !important;
        }
        .hs-form .legal-consent-container .hs-form-field .hs-input {
          height: auto !important;
        }
        .hs-form .legal-consent-container .hs-form-field label,
        .hs-form .legal-consent-container .hs-form-field label span {
          padding-left: 0 !important;
        }
        .hs-form .legal-consent-container .hs-form-field label {
          margin-bottom: 25px;
          font-size: 14px !important;
        }
        .hs-form .legal-consent-container .hs-form-booleancheckbox-display > span {
          margin-left: 0 !important;
        }
        .hs-form .legal-consent-container .hs-richtext {
            font-size: 12px !important;
        }
        .hs-form .hs_submit .hs-button {
          width: 100%;
          font-size: 18px;
          border-radius: 56px;
          padding-block: 20px;
          padding-inline: 40px;
          background-color: #F6A317;
        }
        .hs-form .hs_submit .hs-button:hover {
          font-size: 18px !important;
          background-color: #C58212;
        }
      </style>
    `;

    try {
      container.innerHTML = '';
      
      window.hbspt.forms.create({
        target: `#${containerId}`,
        portalId: "146267455",
        formId: formId,
        region: "eu1",
        onFormReady: function($form) {
          $form.before(formStyle);
        }
      });
    } catch (error) {
      console.error('❌ Error creating HubSpot form:', error);
      container.innerHTML = '<p>Error cargando el formulario. Por favor, recarga la página.</p>';
    }
  }

  if (!window.hbspt) {
    const script = document.createElement('script');
    script.src = '//js-eu1.hsforms.net/forms/embed/v2.js';
    script.charset = 'utf-8';
    script.type = 'text/javascript';
    document.head.appendChild(script);
    
    script.onload = function() {
      initHubSpotForm();
    };
    
    script.onerror = function() {
      console.error('❌ Failed to load HubSpot script');
      container.innerHTML = '<p>Error cargando el formulario. Por favor, verifica tu conexión.</p>';
    };
  } else {
    initHubSpotForm();
  }
}

function initContactForm7(modalContainer) {
  
  const wpcf7Form = modalContainer.querySelector(".wpcf7-form");
  if (wpcf7Form) {
    
    const currentUrl = window.location.pathname;
    const hash = wpcf7Form.action.split("#")[1];
    if (hash) {
      wpcf7Form.action = `${currentUrl}#${hash}`;
    }

    if (typeof wpcf7 !== "undefined" && typeof wpcf7.init === "function") {
      wpcf7.init(wpcf7Form);
    } else {
      console.warn('⚠️ CF7 not available');
    }
  } else {
    console.log('ℹ️ No CF7 form found in this modal');
  }
}

function handleModalCallbacks(modalType, modalContainer) {
  switch (modalType) {
    case 'contact-form-modal':
    case 'contact-form':  // HubSpot form modal
      setTimeout(() => {
        loadHubSpotForm();
      }, 100);
      break;
    
    case 'newsletter':  // HubSpot newsletter form modal
      setTimeout(() => {
        loadHubSpotForm('hubspot-newsletter-form-container');
      }, 100);
      break;
    
    case 'cf7-modal':  // Contact Form 7 modal
    case 'wpcf7-modal': // Contact Form 7 modal
      initContactForm7(modalContainer);
      break;
    
    default:
      console.log('ℹ️ No specific callback for modal type:', modalType);
      break;
  }
}

function initLenisScroll() {
  const lenis = new Lenis({
    prevent: function (element) {
      return element.classList.contains("no-lenis");
    },
  });
  window.lenisInstance = lenis;

  lenis.on(
    "scroll",
    throttle((e) => {
      ScrollTrigger?.update();
      header.handleScroll();
    }, 500)
  );

  gsap.ticker.add((time) => {
    lenis.raf(time * 1000); // Convert time from seconds to milliseconds
  });

  gsap.ticker.lagSmoothing(0);

  return { lenis, addEventListener, gsapTicker: gsap.ticker };
}

document.addEventListener("DOMContentLoaded", () => {
  Swiper.use([Navigation, Pagination]);
  gsap.registerPlugin(gsap.ScrollTrigger);

  // get current scroll position

  const { lenis } = initLenisScroll();
  window.lenis = lenis;

  const hash = window.location.hash;
  if (hash) {
    setTimeout(() => {
      const target = document.querySelector(hash);
      if (target && window.lenis) {
        window.lenis.scrollTo(target, { offset: 0 });
      }
    }, 500);
  }

  // Projects swiper
  const swiperContainer = document.querySelector(".projects-swiper");

  if (swiperContainer) {
    const swiper = new Swiper(".projects-swiper", {
      modules: [Navigation, Pagination],
      slidesPerView: 2,
      spaceBetween: 20,
      loop: false,
      pagination: { el: ".swiper-pagination", clickable: true },
      navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // If development, log a message to the console
  if (process.env.NODE_ENV === "development") {
    console.log("✨ Welcome to Prosolia Theme ✨ Development mode enabled.");
  }
});

// Ejecuta los eventos al cargar el contenido inicialmente
document.addEventListener("DOMContentLoaded", function () {
  addFocusBlurListeners();
});

document.addEventListener("DOMContentLoaded", () => {
  
  document.querySelectorAll("[data-modal]").forEach((el) => {
    el.addEventListener("click", function (event) {
      event.preventDefault();

      const modal = this.getAttribute("data-modal");
      const overlay = document.querySelector(".overlay");
      const modalContainer = document.createElement("div");
      modalContainer.classList.add("modal", `modal--${modal}`);
      overlay.appendChild(modalContainer);

      openModal(modal, modalContainer);
    });
  });

  document.querySelectorAll(".modal").forEach((modal) => {
    modal.addEventListener("click", function (event) {
      const isClickInside = event.target.closest(".modal__content");
      if (!isClickInside) {
        this.style.display = "none";
      }
    });
  });
});


document.addEventListener("click", function (event) {
  const modal = event.target.closest(".overlay");
  if (modal && !event.target.closest(".modal")) {
      modal.classList.remove("overlay--opened");
      modal.removeChild(document.querySelector(".modal"));
  }
  if (event.target.closest(".close-modal")) {
    event.stopPropagation();

    const modal = document.querySelector(".overlay");
    if (modal) {      
      modal.classList.remove("overlay--opened");
      modal.removeChild(document.querySelector(".modal"));
    }

  }
});


function fetchFreshNonce() {
  const data = new FormData();
  data.append("action", "get_load_nonce");

  return fetch(ajax_var.url, {
    method: "POST",
    body: data,
  })
    .then((response) => response.json())
    .then((json) => (json && json.success ? json.data.nonce : ajax_var.nonce))
    .catch(() => ajax_var.nonce);
}

function requestModal(modal, nonce) {
  const data = new FormData();
  data.append("action", ajax_var.action);
  data.append("nonce", nonce);
  data.append("modal", modal);

  return fetch(ajax_var.url, {
    method: "POST",
    body: data,
  }).then((response) => response.text());
}

function openModal(modal, modalContainer) {
  // Request a freshly generated nonce instead of using the one embedded in
  // the page HTML: if a caching plugin serves that page from cache, the
  // embedded nonce may be expired and the server would respond "Busted!".
  fetchFreshNonce()
    .then((nonce) => requestModal(modal, nonce))
    .then((result) => {
      // Safety net: if the nonce was still rejected, retry once more with
      // another fresh nonce before giving up.
      if (result.trim() === "Busted!") {
        return fetchFreshNonce().then((nonce) => requestModal(modal, nonce));
      }
      return result;
    })
    .then((result) => {
      if (modalContainer) {
        document.querySelector(".overlay").classList.add("overlay--opened");

        modalContainer.innerHTML = result;
        modalContainer.style.display = "flex";
        modalContainer.style.opacity = 0;
        modalContainer.style.transition = "opacity 0.3s ease";
        requestAnimationFrame(() => {
          modalContainer.style.opacity = 1;
        });

        addFocusBlurListeners();

        // Ejecutar callbacks específicos según el tipo de modal
        handleModalCallbacks(modal, modalContainer);
      }
    })
    .catch((error) => {
      console.error("Error en la solicitud AJAX:", error);
    });
}

// Función para añadir los eventos focus y blur
function addFocusBlurListeners() {
  document.querySelectorAll(".fieldset input, .fieldset select, .fieldset textarea").forEach((element) => {
    if (!element.dataset.eventAttached) {
      element.addEventListener("focus", function () {
        this.closest(".fieldset").classList.add("active");
      });

      element.addEventListener("blur", function () {
        if (!this.value.trim()) {
          this.closest(".fieldset").classList.remove("active");
        }
      });

      // Marca que los eventos han sido asignados
      element.dataset.eventAttached = true;
    }
  });
}

